import { observer } from 'mobx-react';
import React, { PropsWithChildren } from 'react';

import { SearchContext } from '@elastic/react-search-ui';

import useStores from 'hooks/use-stores';

const ElasticSearchProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { searchStore } = useStores();

    return (
        <SearchContext.Provider value={{ driver: searchStore.elasticSearchDriver }}>{children}</SearchContext.Provider>
    );
};

export default observer(ElasticSearchProvider);
